import { Script } from 'gatsby';
import React, { use } from 'react';

import { SiteContext } from 'src/context/site-context';
import { useLiveChat } from 'src/custom-hooks/use-live-chat';
import type { BuildType } from 'src/enums/build/build-type';
import { getGtmId } from 'src/helpers/config-helper';
import { isAbbySupportedByBuildType } from 'src/helpers/live-chat-helper';

export const TagManager = () => {
  const { buildType } = use(SiteContext);
  const gtmID = getGtmId(buildType);
  return (
    gtmID && (
      <Script id="google-tag-manager-inline-script" type="text/javascript" strategy="idle">
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':` +
          `new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],` +
          `j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=` +
          `'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);` +
          `})(window,document,'script','dataLayer','${gtmID}');`}
      </Script>
    )
  );
};

export type SnippetsProps = {
  buildType: BuildType;
  chatEnabled?: boolean | null;
  abbyChatEnabled?: boolean;
  disableAnalyticsCookies?: boolean;
};

const Snippets: React.FC<SnippetsProps> = ({
  buildType,
  chatEnabled,
  disableAnalyticsCookies,
  abbyChatEnabled,
}: SnippetsProps) => {
  const { isContentPreviewMode } = use(SiteContext);
  if (isContentPreviewMode) {
    return;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks -- Preview mode is invariant
  useLiveChat({ liveChatEnabled: !!chatEnabled, abbyChatEnabled });
  return (
    <>
      {!disableAnalyticsCookies && <TagManager />}
      {abbyChatEnabled && isAbbySupportedByBuildType(buildType) && (
        <Script src="https://app.salesape.ai/static/chat/js/chat-widget.js" />
      )}
    </>
  );
};

export default Snippets;
